import waterwayData from './gazetteer/waterways.json' with { type: 'json' };

/**
 * Named waterways that the base map's own tiles do not label.
 *
 * OpenStreetMap-derived vector tiles carry bays, inlets and harbors, but almost
 * no passages, straits or channels — yet those are exactly the names observers
 * use for where whales are and where they are heading next ("in Colvos
 * Passage", "off Hale Passage"). This list fills that gap.
 *
 * Every point was checked against the water polygons in the vector tiles, and
 * any that fell on land were moved to the nearest water with at least 300 m of
 * clearance, so a label never lands on shore.
 */
export interface Waterway {
  id: string;
  name: string;
  kind: 'sound' | 'strait' | 'canal' | 'passage' | 'channel' | 'reach' | 'inlet';
  /**
   * 1 = major body (visible when zoomed out), 2 = channel, 3 = narrow passage
   * (only legible once zoomed in). Drives the zoom at which the label appears.
   */
  tier: 1 | 2 | 3;
  /** Text rotation in degrees clockwise, following the channel axis. */
  angle: number;
  lat: number;
  lon: number;
}

export const WATERWAYS: Waterway[] = waterwayData as Waterway[];
